import { apiAction } from '../../../shared/store/apiAction';

import * as api from './api';
import { fetchJobQueueStatusReportsTypes, terminateStuckCalcJobTypes } from './types';

export const fetchJobQueueStatusReports = apiAction({
  types: fetchJobQueueStatusReportsTypes,
  apiAction: api.fetchJobQueueStatusReports,
});

export const terminateStuckCalcJob = apiAction({
  types: terminateStuckCalcJobTypes,
  apiAction: api.terminateStuckCalcJob,
});
